import { useEffect } from 'react'

const useBodyDataProperty = (property: string) => {
  useEffect(() => {
    document.body.setAttribute(property, 'true')
    return () => {
      document.body.removeAttribute(property)
    }
  }, [property])
}

export default useBodyDataProperty
